<template>
    <template v-if="loading">
            <Preloader></Preloader>
    </template>
    <template v-else>
        <Header></Header>
        <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
                <component :is="Component" />
            </transition>
        </router-view>
        <Footer></Footer>
    </template>

    <title data-lang="site_title">{{__('Cloud Mods – игровые модификации')}}</title>
</template>

<style>

input, input:focus, input:active, textarea, textarea:focus, textarea:active {
    user-select: auto;
    font-family: 'TT Interfaces', sans-serif !important;
    resize: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    background: none;
    border: 0 solid transparent;
    box-sizing: border-box;
    font-size: 100%;
    margin: 0;
    outline: 0;
    padding: 0;
    caret-color: var(--text-accent);
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-box-shadow: inset 0 0 0 30px #0D0D0D !important;
    -webkit-text-fill-color: var(--text-accent) !important;
    background-clip: content-box;
    font-family: "TT Interfaces", sans-serif !important;
    /*
    transition: background-color 5500s ease-in-out 0s;
    -webkit-text-fill-color: white !important;
    font-family: "TT Interfaces", sans-serif;
     */

}

.fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    //backdrop-filter: opacity(0);
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
    font-family: "TT Interfaces", sans-serif !important;
}

a, a:focus, a:active, a:visited {
    color: inherit;
    text-decoration: inherit;
}

:root {
    --bg-primary: #040404;
    --bg-secondary: #090909;
    --bg-accent: #0D0D0D;
    --text-primary: #fff;
    --text-accent: #E0E0E0;
    --text-secondary: #848484;
    --button-main: #171717;
    --button-main-hover: #0F0F0F;
    --button-accent: #0F0F0F;
    --button-accent-hover: #0A0A0A;
    --icon-main: #4F4F4F;
    --color-main: #7853FF;
}

* {
    box-sizing: border-box;
    font-family: 'TT Interfaces';
}

html, body {
    -webkit-overflow-scrolling: touch; /* Плавный скролл для iOS */
    overflow: auto; /* Убедись, что прокрутка разрешена */
    overscroll-behavior: none; /* Предотвращает прыжки при прокрутке */
}

html,
body {
    height: 100%;

    scrollbar-color: var(--color-main) var(--button-accent);
    scrollbar-width: thin;
    position: relative;

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background: var(--bg-primary);

    color: var(--text-primary);
    font-weight: 600;

    margin: 0;
}

</style>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Home from "@/pages/Home.vue";
import EventEmitter from '@/utils/eventEmitter'
import Preloader from "@/components/Preloader.vue";
import Hero from "@/components/Hero.vue";

export default {
    data() {
        return {
            loading: true,
        }
    },
    mounted() {
        this.loadContent()
    },
    methods: {
        async loadContent() {
            await new Promise(resolve => setTimeout(resolve, 1200))
            this.loading = false
        },
    },
    components: {Hero, Preloader, Home, Footer, Header},
    async created() {
        // console.log('App created')
        console.log(this.$route)

        if(!localStorage.getItem('lang')) {
            localStorage.setItem('lang', navigator.language.split('-')[0])
        }

        this.$store.state.lang = localStorage.getItem('lang')
    }
}
</script>